export default __webpack_public_path__ + "static/media/Icon_BattleSlots.df134e08.svg";